import EditableCard from './EditableCard';

export default EditableCard;
